import axios from 'axios';
import { useAuthStore } from '../stores/authStore';

export const apiInstance = axios.create({
    baseURL: process.env.VUE_APP_URL_API || 'https://localhost:8000/api/v1',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

// INTERCEPTOR DE PETICIÓN: Pega el token en cada llamada
apiInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token_cf');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// INTERCEPTOR DE RESPUESTA: Si el backend dice 401, mandamos al usuario al login
apiInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const authStore = useAuthStore();
            authStore.logout();
            localStorage.removeItem('access_token_cf');
            alert("Tu sesión ha expirado por seguridad. Por favor, ingresa de nuevo.");
            // window.location.href = '/login'; // O redirige con vue-router
        }
        return Promise.reject(error);
    }
);